import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Truck } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data.user);
        navigate("/", { replace: true });
      } catch {
        setError("La connexion Google a échoué. Réessayez.");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#0c111c] text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#ff6a00] shadow-[0_0_30px_rgba(255,106,0,0.5)]">
        <Truck className="h-7 w-7 text-white" />
      </div>
      {error ? (
        <>
          <p className="text-sm text-rose-400">{error}</p>
          <button onClick={() => navigate("/", { replace: true })} className="text-sm text-[#ff6a00] underline">
            Retour
          </button>
        </>
      ) : (
        <p className="flex items-center gap-2 text-sm text-slate-400">
          <Loader2 className="h-4 w-4 animate-spin" /> Connexion en cours…
        </p>
      )}
    </div>
  );
}
